import { AxiosResponse, AxiosError } from 'axios';
import { logger } from '../../../../lib/logger';

const delay = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));

export const withRetryOnTimeout = async <T = any>(
    axiosCall: () => Promise<AxiosResponse<T>>
): Promise<AxiosResponse<T>> => {
    const maxRetries = 3;

    for (let attempt = 0; attempt <= maxRetries; attempt++) {
        try {
            return await axiosCall();
        } catch (error) {
            const axiosError = error as AxiosError;
            const status = axiosError.response?.status;

            if ((status === 408 || status === 500 || status === 504) && attempt < maxRetries) {
                const delayMs = 300 * Math.pow(2, attempt);
                logger.info(
                    `Request got ${status}, retrying after ${delayMs}ms (attempt ${attempt + 1}/${maxRetries})`
                );
                await delay(delayMs);
                continue;
            }

            throw error;
        }
    }

    throw new Error('Should not reach here');
};
